import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AddressCoords } from '@core/interfaces';
@Component({
  selector: 'tab-general',
  templateUrl: './tab-general.component.html',
  styleUrls: ['./tab-general.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabGeneralComponent {
  @Input() reallocateMaintenancesForm: FormGroup;
  @Input() locationAddressCoords: AddressCoords;

  constructor() { }
}
